import { render, staticRenderFns } from "./Disponibilidade.vue?vue&type=template&id=05ac7b1b&scoped=true&"
import script from "./Disponibilidade.vue?vue&type=script&lang=js&"
export * from "./Disponibilidade.vue?vue&type=script&lang=js&"
import style0 from "./Disponibilidade.vue?vue&type=style&index=0&id=05ac7b1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac7b1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
